import React from 'react';
import { IconHeartOutlined, IconHeartFilled } from '@prisjakt/ui/icon';
import { useAppContext } from '@prisjakt/ui-app-context';
import { Direction } from '@prisjakt/ui';
import { ButtonIcon } from '@prisjakt/ui/button';
import { Tooltip, ButtonText, Button } from './styles';

export const SaveToListButton: React.VFC<SaveToListButtonProps> = ({
  isActive,
  onClick,
}) => {
  const { t } = useAppContext();

  return (
    <Tooltip
      title={t('product', 'action-button.list-tooltip')}
      placement={Direction.Down}
      width={180}
      zIndex={1}
    >
      <Button ariaLabel={t('common', 'button.save')} onClick={onClick}>
        <ButtonIcon>
          {isActive ? <IconHeartFilled /> : <IconHeartOutlined />}
        </ButtonIcon>
        <ButtonText>{t('common', 'button.save')}</ButtonText>
      </Button>
    </Tooltip>
  );
};

interface SaveToListButtonProps {
  isActive: boolean;
  onClick?: () => void;
}
